import { invitation, requestState } from "../actions/index";

export default (initialState, action) => {
	switch (action.type) {
		case requestState.LOADING:
			return {
				...initialState,
				loading: true,
			};

		case invitation.GET_INVITATIONS:
			localStorage.setItem("code", action.payload.code);
			return {
				...initialState,
				...action.payload,
				loading: false,
				invitations: action.payload.invitations,
				referreds: action.payload.referreds,
			};
		case invitation.GET_REFERREDS:
			return {
				...initialState,
				loading: false,
				referreds: action.payload,
			};
		case invitation.GET_INVITATION_CODE:
			return {
				...initialState,
				loading: false,
				code: action.payload,
			};
		case invitation.SEND_INVITATION:
			return {
				...initialState,
				loading: false,
				success: `Invitation sent to ${action.payload}`,
			};
		case requestState.ERROR:
			return {
				...initialState,
				loading: false,
				error: action.payload,
			};

		case requestState.CLEAR_NOTIFICATION:
			return {
				...initialState,
				error: null,
				success: null,
			};
		default:
			return initialState;
	}
};
